export var AUTH0_LOGIN_REDIRECT_INFO_KEY = 'auth0_login_redirect_info';
export var JOVE_CMS_USER_INFO_CACHE_KEY = 'JOVE_CMS_USER_INFO_CACHE_KEY';
export var JOVE_UNIVERSAL_AUTH_SESSION_KEY = 'jove-universal-auth-session';
export var joveMasterAdminEmailList = ['amanda.cai@jove.co', 'james.blake@jove.co', 'hao.liu@jove.co'];
export var joveMasterAdminEmailListWithHaoTeam = [].concat(joveMasterAdminEmailList);